// src/components/cards/StatusCard.jsx
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const StatusCard = ({ title, count, icon, color, onClick }) => {
  const theme = useTheme();

  const cardStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    borderRadius: '16px',
    backgroundColor: theme.palette.mode === 'light'
      ? '#ffffff'
      : '#1e1e1e',
    boxShadow: theme.shadows[4],
    border: `1px solid ${color}22`,
    textAlign: 'center',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      //transform: 'translateY(-4px)',
      //boxShadow: theme.shadows[8],
      transform: onClick ? 'translateY(-4px)' : 'none',
      boxShadow: onClick ? theme.shadows[8] : theme.shadows[4],
    },
  };

  const iconStyle = {
    fontSize: '2.5rem',
    marginBottom: theme.spacing(1),
  };

  const countStyle = {
    fontWeight: 'bold',
    fontSize: '1.8rem',
    color: color,
    marginTop: theme.spacing(0.5),
  };

  return (
    <Box sx={cardStyle} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
      <Typography variant="h4" sx={{ ...iconStyle, color }}>
        {icon}
      </Typography>
      <Typography variant="body2" color="textSecondary" fontWeight="medium">
        {title}
      </Typography>
      <Typography variant="h5" sx={countStyle}>
        {count}
      </Typography>
    </Box>
  );
};

export default StatusCard;